import { useMemo } from 'react';
import { useSubNavStore, type SubNavStore } from '@frontend/nav-primitives';
import { useLocation } from '@frontend/weave-router';
import { SectionTitle } from './headers';

const selectNavItem = (currentRoot: string) => (state: SubNavStore) => state.parentNavData?.[currentRoot];

export const RouterBreadcrumb = () => {
  const currentPath = useLocation().pathname;

  const currentRoot = useMemo(() => {
    const [, ...pathParts] = currentPath?.split('/') ?? [];
    return `/${pathParts?.[0] ?? ''}`;
  }, [currentPath]);

  const navItem = useSubNavStore(useMemo(() => selectNavItem(currentRoot), [currentRoot]));

  return <SectionTitle>{navItem?.label ?? ''}</SectionTitle>;
};
